import RegionLanguage from '../content/region_lang';
import RegistrationCriteria from '../content/reg_ctr';
import CompanyInfo from '../content/company_info';
import AddContacts from '../content/add_conts';
import ProgramAgreement from '../content/prog_agmnt';
import Finish from '../content/finish';

import NonPartnerAccount from '../content/nonPartnerAcc';
import RegAnotherProg from '../content/regWithAnotherProg';
import GenericError from '../content/genericError';
import ErrorAlreadyRegistered from '../../components/pages/error/ErrorAlreadyRegistered';
import BlankLoader from '../../components/pages/error/BlankLoader';

const ContentMap = {
    forms: [
        { id: "RegionLanguage", component: RegionLanguage },
        { id: "RegistrationCriteria", component: RegistrationCriteria },
        { id: "CompanyInfo", component: CompanyInfo },
        { id: "AddContacts", component: AddContacts },
        { id: "ProgramAgreement", component: ProgramAgreement },
        { id: "Finish", component: Finish },
      ],
    unavailable : [RegAnotherProg,BlankLoader,NonPartnerAccount,GenericError],
    languageNameCode : {English: 'en_US', Chinese: 'zh_CN', French: 'fr_FR', German: 'de_DE', Italian: 'it_IT', Japanese: 'ja_JP', Korean: 'ko_KR', Spanish: 'es_ES'},
};

export {ContentMap};